import {
    type ReactNode
} from "react";
import NCoreUIKitBottomSheet from "./bottomSheet";
import NCoreUIKitDialog from "./dialog";
import NCoreUIKitEmbeddedMenu from "./embeddedMenu";
import NCoreUIKitLocalize from "./localize";
import NCoreUIKitMenu from "./menu";
import NCoreUIKitModal from "./modal";
import NCoreUIKitSnackBar from "./snackBar";
import NCoreUIKitTheme from "./theme";
import NCoreUIKitToast from "./toast";
import {
    type NCoreUIKitConfig
} from "../types";
import {
    SNACK_BAR_PORTAL_NAME,
    POPOVER_PORTAL_NAME
} from "../helpers/portalize/context";
import {
    Host
} from "../helpers/portalize";
import DirectionRoot from "../components/directionProvider/components/root";

class CoreContext<T extends NCoreUIKitConfig> {
    NCoreUIKitEmbeddedMenu: NCoreUIKitEmbeddedMenu;
    NCoreUIKitBottomSheet: NCoreUIKitBottomSheet;
    NCoreUIKitLocalize: NCoreUIKitLocalize<T>;
    NCoreUIKitSnackBar: NCoreUIKitSnackBar;
    NCoreUIKitTheme: NCoreUIKitTheme<T>;
    NCoreUIKitDialog: NCoreUIKitDialog;
    NCoreUIKitModal: NCoreUIKitModal;
    NCoreUIKitToast: NCoreUIKitToast;
    NCoreUIKitMenu: NCoreUIKitMenu;

    constructor(initialState: T) {
        this.NCoreUIKitTheme = new NCoreUIKitTheme({
            initialSelectedActiveSharpness: initialState.initialSelectedActiveSharpness,
            initialSelectedGapPropagation: initialState.initialSelectedGapPropagation,
            initialSelectedPalette: initialState.initialSelectedPalette,
            initialSelectedTheme: initialState.initialSelectedTheme,
            projectThemes: initialState.projectThemes
        });

        this.NCoreUIKitLocalize = new NCoreUIKitLocalize({
            initialSelectedLocale: initialState.initialSelectedLocale,
            onDirectionChange: initialState.onDirectionChange,
            projectLocales: initialState.projectLocales
        });

        this.NCoreUIKitModal = new NCoreUIKitModal({
            data: []
        });

        this.NCoreUIKitToast = new NCoreUIKitToast({
            isAlwaysExpanded: initialState.isToastAlwaysExpanded,
            data: []
        });

        this.NCoreUIKitSnackBar = new NCoreUIKitSnackBar({
            data: []
        });

        this.NCoreUIKitDialog = new NCoreUIKitDialog({
            data: []
        });

        this.NCoreUIKitBottomSheet = new NCoreUIKitBottomSheet({
            data: []
        });

        this.NCoreUIKitMenu = new NCoreUIKitMenu({
            data: []
        });

        this.NCoreUIKitEmbeddedMenu = new NCoreUIKitEmbeddedMenu({
            data: []
        });
    }

    Provider = ({
        children
    }: {
        children: ReactNode
    }) => {
        const EmbeddedMenuContext = this.NCoreUIKitEmbeddedMenu;
        const BottomSheetContext = this.NCoreUIKitBottomSheet;
        const LocalizeContext = this.NCoreUIKitLocalize;
        const SnackBarContext = this.NCoreUIKitSnackBar;
        const DialogContext = this.NCoreUIKitDialog;
        const ModalContext = this.NCoreUIKitModal;
        const ToastContext = this.NCoreUIKitToast;
        const ThemeContext = this.NCoreUIKitTheme;
        const MenuContext = this.NCoreUIKitMenu;

        return <ThemeContext.Provider>
            <LocalizeContext.Provider>
                <DirectionRoot
                    onDirectionChange={LocalizeContext.onDirectionChange}
                >
                    <Host
                        name={POPOVER_PORTAL_NAME}
                    >
                        <Host
                            name={SNACK_BAR_PORTAL_NAME}
                        >
                            <SnackBarContext.Provider>
                                <SnackBarContext.Render>
                                    <Host
                                        name="toast-system"
                                    >
                                        <Host
                                            name="modal-system"
                                        >
                                            <ModalContext.Provider>
                                                <ModalContext.Render>
                                                    <DialogContext.Provider>
                                                        <DialogContext.Render>
                                                            <ToastContext.Provider>
                                                                <ToastContext.Render>
                                                                    <Host
                                                                        name="bottomSheet-system"
                                                                    >
                                                                        <BottomSheetContext.Provider>
                                                                            <BottomSheetContext.Render>
                                                                                <Host
                                                                                    name="menu-system"
                                                                                >
                                                                                    <MenuContext.Provider>
                                                                                        <MenuContext.Render>
                                                                                            <EmbeddedMenuContext.Provider>
                                                                                                {children}
                                                                                            </EmbeddedMenuContext.Provider>
                                                                                        </MenuContext.Render>
                                                                                    </MenuContext.Provider>
                                                                                </Host>
                                                                            </BottomSheetContext.Render>
                                                                        </BottomSheetContext.Provider>
                                                                    </Host>
                                                                </ToastContext.Render>
                                                            </ToastContext.Provider>
                                                        </DialogContext.Render>
                                                    </DialogContext.Provider>
                                                </ModalContext.Render>
                                            </ModalContext.Provider>
                                        </Host>
                                    </Host>
                                </SnackBarContext.Render>
                            </SnackBarContext.Provider>
                        </Host>
                    </Host>
                </DirectionRoot>
            </LocalizeContext.Provider>
        </ThemeContext.Provider>;
    };
};
export default CoreContext;
